import Vue from "vue";
import ServiceCard from "./ServiceCard.vue";

export function load() {
    const selector = "service-card-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(ServiceCard, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
